import BaseService from '@/services/BaseService'
import { http } from './config'
class AtividadeOsService extends BaseService {
    constructor(){
        super('/v1/ordem-servico/atividades')
    }

    listar(data){
        return http.get(`/v1/ordem-servico/atividades?ordem_servico_id=${data.id}`)
    }
}

export default new AtividadeOsService